import { Heading } from '@/components/Heading';
import type { HighlightColour, NavSubsection } from '@/types';
import * as Styled from './MenuToggle.styled';
import { NavItem } from './NavItem';

interface FeaturedLinksProps {
  data: NavSubsection;
  highlightColour?: HighlightColour;
}

export const FeaturedLinks = ({ data, highlightColour }: FeaturedLinksProps) => (
  <Styled.FeaturedLinks $highlightColour={highlightColour}>
    <Heading level={2} styledAs={3}>
      {data.heading.textContent}
    </Heading>
    <ul>
      {data.links.map(link => (
        <NavItem key={link.href} link={link} />
      ))}
    </ul>
  </Styled.FeaturedLinks>
);
